import { Injectable } from '@angular/core';
import { GlobalSelectionControlService } from '../map/services/global-selection-control.service';
import { Project } from '../models/project';

@Injectable({
  providedIn: 'root'
})
export class AddProjectControlService {
  public active : boolean;
  public selectedProject : Project = new Project();

  constructor() { }
}
